var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.Cargando,"absolute":"","opacity":"1"}},[_c('v-container',{attrs:{"align":"center","justify":"center"}},[_c('v-row',[_c('img',{attrs:{"src":_vm.cargando,"width":"550px"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }